var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preview-wrapper"},[_c('b-form-textarea',{attrs:{"plaintext":"","value":_vm.data,"rows":_vm.rows}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }